import type { Module } from 'vuex';
import { LOCAL_STORAGE_KEYS, setLocalStorageValue, removeLocalStorageValue, getLocalStorageValue } from '@/constants/localStorage';
import {RootState} from "@/store";

export type Theme = 'light' | 'dark' | 'auto' | null;

export interface ThemeState {
  theme: Theme;
  themeDoNotShow: boolean;
}

const themeModule: Module<ThemeState, RootState> = {
  namespaced: true,

  state: (): ThemeState => ({
    theme: 'auto',
    themeDoNotShow: false,
  }),

  getters: {
    currentTheme: (state): Theme => state.theme,
    isThemeDoNotShow: (state): boolean => state.themeDoNotShow,
  },

  mutations: {
    setTheme(
      state,
      payload: Theme
    ) {
      if (['light', 'dark', 'auto', null].includes(payload)) {
        state.theme = payload;
      } else {
        state.theme = null;
      }

      if (state.theme === null) {
        removeLocalStorageValue(LOCAL_STORAGE_KEYS.THEME);
      } else if (getLocalStorageValue(LOCAL_STORAGE_KEYS.THEME) !== state.theme) {
        setLocalStorageValue(LOCAL_STORAGE_KEYS.THEME, state.theme);
      }
    },

    setThemeDoNotShow(
      state,
      payload: boolean
    ) {
      state.themeDoNotShow = payload;
      if (payload) {
        setLocalStorageValue(LOCAL_STORAGE_KEYS.THEME_DO_NOT_SHOW, 'true');
      } else {
        removeLocalStorageValue(LOCAL_STORAGE_KEYS.THEME_DO_NOT_SHOW);
      }
    },
  },

  actions: {
    setTheme({ commit }, payload) {
      commit('setTheme', payload);
    },

    setThemeDoNotShow({ commit }, payload) {
      commit('setThemeDoNotShow', payload);
    },
  },
};

export default themeModule; 